export interface Country {
  nameKor: string;
  nameEng: string;
  code: string;
  code3: string;
  phone: string;
}

export const countries: Country[] = [
  { nameKor: '가나', nameEng: 'Ghana', code: 'GH', code3: 'GHA', phone: '233' },
  { nameKor: '가봉', nameEng: 'Gabon', code: 'GA', code3: 'GAB', phone: '241' },
  {
    nameKor: '가이아나',
    nameEng: 'Guyana',
    code: 'GY',
    code3: 'GUY',
    phone: '592',
  },
  {
    nameKor: '감비아',
    nameEng: 'Gambia',
    code: 'GM',
    code3: 'GMB',
    phone: '220',
  },
  { nameKor: '괌', nameEng: 'Guam', code: 'GU', code3: 'GUM', phone: '1671' },
  {
    nameKor: '과들루프',
    nameEng: 'Guadeloupe',
    code: 'GP',
    code3: 'GLP',
    phone: '590',
  },
  {
    nameKor: '과테말라',
    nameEng: 'Guatemala',
    code: 'GT',
    code3: 'GTM',
    phone: '502',
  },
  {
    nameKor: '그레나다',
    nameEng: 'Grenada',
    code: 'GD',
    code3: 'GRD',
    phone: '1473',
  },
  {
    nameKor: '그리스',
    nameEng: 'Greece',
    code: 'GR',
    code3: 'GRC',
    phone: '30',
  },
  {
    nameKor: '그린란드',
    nameEng: 'Greenland',
    code: 'GL',
    code3: 'GRL',
    phone: '299',
  },
  {
    nameKor: '기니',
    nameEng: 'Guinea',
    code: 'GN',
    code3: 'GIN',
    phone: '224',
  },
  {
    nameKor: '기니비사우',
    nameEng: 'Guinea-Bissau',
    code: 'GW',
    code3: 'GNB',
    phone: '245',
  },
  {
    nameKor: '나미비아',
    nameEng: 'Namibia',
    code: 'NA',
    code3: 'NAM',
    phone: '264',
  },
  {
    nameKor: '나우루',
    nameEng: 'Nauru',
    code: 'NR',
    code3: 'NRU',
    phone: '674',
  },
  {
    nameKor: '나이지리아',
    nameEng: 'Nigeria',
    code: 'NG',
    code3: 'NGA',
    phone: '234',
  },
  {
    nameKor: '남수단',
    nameEng: 'South Sudan',
    code: 'SS',
    code3: 'SSD',
    phone: '211',
  },
  {
    nameKor: '남아프리카 공화국',
    nameEng: 'South Africa',
    code: 'ZA',
    code3: 'ZAF',
    phone: '27',
  },
  {
    nameKor: '네덜란드',
    nameEng: 'the Netherlands',
    code: 'NL',
    code3: 'NLD',
    phone: '31',
  },
  { nameKor: '네팔', nameEng: 'Nepal', code: 'NP', code3: 'NPL', phone: '977' },
  {
    nameKor: '노르웨이',
    nameEng: 'Norway',
    code: 'NO',
    code3: 'NOR',
    phone: '47',
  },
  {
    nameKor: '누벨칼레도니',
    nameEng: 'New Caledonia',
    code: 'NC',
    code3: 'NCL',
    phone: '687',
  },
  {
    nameKor: '뉴질랜드',
    nameEng: 'New Zealand',
    code: 'NZ',
    code3: 'NZL',
    phone: '64',
  },
  {
    nameKor: '니우에',
    nameEng: 'Niue',
    code: 'NU',
    code3: 'NIU',
    phone: '683',
  },
  {
    nameKor: '니제르',
    nameEng: 'Niger',
    code: 'NE',
    code3: 'NER',
    phone: '227',
  },
  {
    nameKor: '니카라과',
    nameEng: 'Nicaragua',
    code: 'NI',
    code3: 'NIC',
    phone: '505',
  },
  {
    nameKor: '대한민국',
    nameEng: 'Republic of Korea',
    code: 'KR',
    code3: 'KOR',
    phone: '82',
  },
  {
    nameKor: '덴마크',
    nameEng: 'Denmark',
    code: 'DK',
    code3: 'DNK',
    phone: '45',
  },
  {
    nameKor: '도미니카 공화국',
    nameEng: 'Dominican R.',
    code: 'DO',
    code3: 'DOM',
    phone: '1809',
  },
  {
    nameKor: '도미니카 연방',
    nameEng: 'Dominica',
    code: 'DM',
    code3: 'DMA',
    phone: '1767',
  },
  {
    nameKor: '독일',
    nameEng: 'Germany',
    code: 'DE',
    code3: 'DEU',
    phone: '49',
  },
  {
    nameKor: '동티모르',
    nameEng: 'East Timor',
    code: 'TL',
    code3: 'TLS',
    phone: '670',
  },
  {
    nameKor: '라오스',
    nameEng: 'Laos',
    code: 'LA',
    code3: 'LAO',
    phone: '856',
  },
  {
    nameKor: '라이베리아',
    nameEng: 'Liberia',
    code: 'LR',
    code3: 'LBR',
    phone: '231',
  },
  {
    nameKor: '라트비아',
    nameEng: 'Latvia',
    code: 'LV',
    code3: 'LVA',
    phone: '371',
  },
  {
    nameKor: '러시아',
    nameEng: 'Russia',
    code: 'RU',
    code3: 'RUS',
    phone: '7',
  },
  {
    nameKor: '레바논',
    nameEng: 'Lebanon',
    code: 'LB',
    code3: 'LBN',
    phone: '961',
  },
  {
    nameKor: '레소토',
    nameEng: 'Lesotho',
    code: 'LS',
    code3: 'LSO',
    phone: '266',
  },
  {
    nameKor: '루마니아',
    nameEng: 'Romania',
    code: 'RO',
    code3: 'ROU',
    phone: '40',
  },
  {
    nameKor: '룩셈부르크',
    nameEng: 'Luxembourg',
    code: 'LU',
    code3: 'LUX',
    phone: '352',
  },
  {
    nameKor: '르완다',
    nameEng: 'Rwanda',
    code: 'RW',
    code3: 'RWA',
    phone: '250',
  },
  {
    nameKor: '리비아',
    nameEng: 'Libya',
    code: 'LY',
    code3: 'LBY',
    phone: '218',
  },
  {
    nameKor: '리투아니아',
    nameEng: 'Lithuania',
    code: 'LT',
    code3: 'LTU',
    phone: '370',
  },
  {
    nameKor: '리히텐슈타인',
    nameEng: 'Liechtenstein',
    code: 'LI',
    code3: 'LIE',
    phone: '423',
  },
  {
    nameKor: '마다가스카르',
    nameEng: 'Madagascar',
    code: 'MG',
    code3: 'MDG',
    phone: '261',
  },
  {
    nameKor: '마르티니크',
    nameEng: 'Martinique',
    code: 'MQ',
    code3: 'MTQ',
    phone: '596',
  },
  {
    nameKor: '마셜 제도',
    nameEng: 'Marshall Islands',
    code: 'MH',
    code3: 'MHL',
    phone: '692',
  },
  {
    nameKor: '마요트',
    nameEng: 'Mayotte',
    code: 'YT',
    code3: 'MYT',
    phone: '269',
  },
  {
    nameKor: '마카오',
    nameEng: 'Macao',
    code: 'MO',
    code3: 'MAC',
    phone: '853',
  },
  {
    nameKor: '말라위',
    nameEng: 'Malawi',
    code: 'MW',
    code3: 'MWI',
    phone: '265',
  },
  {
    nameKor: '말레이시아',
    nameEng: 'Malaysia',
    code: 'MY',
    code3: 'MYS',
    phone: '60',
  },
  { nameKor: '말리', nameEng: 'Mali', code: 'ML', code3: 'MLI', phone: '223' },
  {
    nameKor: '멕시코',
    nameEng: 'Mexico',
    code: 'MX',
    code3: 'MEX',
    phone: '52',
  },
  {
    nameKor: '모나코',
    nameEng: 'Monaco',
    code: 'MC',
    code3: 'MCO',
    phone: '377',
  },
  {
    nameKor: '모로코',
    nameEng: 'Morocco',
    code: 'MA',
    code3: 'MAR',
    phone: '212',
  },
  {
    nameKor: '모리셔스',
    nameEng: 'Mauritius',
    code: 'MU',
    code3: 'MUS',
    phone: '230',
  },
  {
    nameKor: '모리타니',
    nameEng: 'Mauritania',
    code: 'MR',
    code3: 'MRT',
    phone: '222',
  },
  {
    nameKor: '모잠비크',
    nameEng: 'Mozambique',
    code: 'MZ',
    code3: 'MOZ',
    phone: '258',
  },
  {
    nameKor: '몬테네그로',
    nameEng: 'Montenegro',
    code: 'ME',
    code3: 'MNE',
    phone: '382',
  },
  {
    nameKor: '몬트세랫',
    nameEng: 'Montserrat',
    code: 'MS',
    code3: 'MSR',
    phone: '1664',
  },
  {
    nameKor: '몰도바',
    nameEng: 'Maldova',
    code: 'MD',
    code3: 'MDA',
    phone: '373',
  },
  {
    nameKor: '몰디브',
    nameEng: 'Maldives',
    code: 'MV',
    code3: 'MDV',
    phone: '960',
  },
  { nameKor: '몰타', nameEng: 'Malta', code: 'MT', code3: 'MLT', phone: '356' },
  {
    nameKor: '몽골',
    nameEng: 'Mongolia',
    code: 'MN',
    code3: 'MNG',
    phone: '976',
  },
  {
    nameKor: '미국',
    nameEng: 'United States of America',
    code: 'US',
    code3: 'USA',
    phone: '1',
  },
  {
    nameKor: '미얀마(버마',
    nameEng: 'Myanmar',
    code: 'MM',
    code3: 'MMR',
    phone: '95',
  },
  {
    nameKor: '미크로네시아 연방',
    nameEng: 'Micronesia',
    code: 'FM',
    code3: 'FSM',
    phone: '691',
  },
  {
    nameKor: '바누아투',
    nameEng: 'Vanuatu',
    code: 'VU',
    code3: 'VUT',
    phone: '678',
  },
  {
    nameKor: '바레인',
    nameEng: 'Bahrain',
    code: 'BH',
    code3: 'BHR',
    phone: '973',
  },
  {
    nameKor: '바베이도스',
    nameEng: 'Barbados',
    code: 'BB',
    code3: 'BRB',
    phone: '1246',
  },
  {
    nameKor: '바티칸 시국',
    nameEng: 'Vatican',
    code: 'VA',
    code3: 'VAT',
    phone: '379',
  },
  {
    nameKor: '바하마',
    nameEng: 'Bahamas',
    code: 'BS',
    code3: 'BHS',
    phone: '1242',
  },
  {
    nameKor: '방글라데시',
    nameEng: 'Bangladesh',
    code: 'BD',
    code3: 'BGD',
    phone: '880',
  },
  {
    nameKor: '버뮤다',
    nameEng: 'Bermuda',
    code: 'BM',
    code3: 'BMU',
    phone: '1441',
  },
  { nameKor: '베냉', nameEng: 'Benin', code: 'BJ', code3: 'BEN', phone: '229' },
  {
    nameKor: '베네수엘라',
    nameEng: 'Venezuela',
    code: 'VE',
    code3: 'VEN',
    phone: '58',
  },
  {
    nameKor: '베트남',
    nameEng: 'Vietnam',
    code: 'VN',
    code3: 'VNM',
    phone: '84',
  },
  {
    nameKor: '벨기에',
    nameEng: 'Belgium',
    code: 'BE',
    code3: 'BEL',
    phone: '32',
  },
  {
    nameKor: '벨라루스',
    nameEng: 'Belarus',
    code: 'BY',
    code3: 'BLR',
    phone: '375',
  },
  {
    nameKor: '벨리즈',
    nameEng: 'Belize',
    code: 'BZ',
    code3: 'BLZ',
    phone: '501',
  },
  {
    nameKor: '보스니아 헤르체고비나',
    nameEng: 'Bosnia and Herzegovina',
    code: 'BA',
    code3: 'BIH',
    phone: '387',
  },
  {
    nameKor: '보츠와나',
    nameEng: 'Botswana',
    code: 'BW',
    code3: 'BWA',
    phone: '267',
  },
  {
    nameKor: '볼리비아',
    nameEng: 'Bolivia',
    code: 'BO',
    code3: 'BOL',
    phone: '591',
  },
  {
    nameKor: '부룬디',
    nameEng: 'Burundi',
    code: 'BI',
    code3: 'BDI',
    phone: '257',
  },
  {
    nameKor: '부르키나파소',
    nameEng: 'Burkina Faso',
    code: 'BF',
    code3: 'BFA',
    phone: '226',
  },
  {
    nameKor: '부탄',
    nameEng: 'Bhutan',
    code: 'BT',
    code3: 'BTN',
    phone: '975',
  },
  {
    nameKor: '북마케도니아',
    nameEng: 'Macedonia',
    code: 'MK',
    code3: 'MKD',
    phone: '389',
  },
  {
    nameKor: '불가리아',
    nameEng: 'Bulgaria',
    code: 'BG',
    code3: 'BGR',
    phone: '359',
  },
  {
    nameKor: '브라질',
    nameEng: 'Brazil',
    code: 'BR',
    code3: 'BRA',
    phone: '55',
  },
  {
    nameKor: '브루나이',
    nameEng: 'Brunei',
    code: 'BN',
    code3: 'BRN',
    phone: '673',
  },
  {
    nameKor: '사모아',
    nameEng: 'Samoa',
    code: 'WS',
    code3: 'WSM',
    phone: '685',
  },
  {
    nameKor: '사우디아라비아',
    nameEng: 'Saudi Arabia',
    code: 'SA',
    code3: 'SAU',
    phone: '966',
  },
  {
    nameKor: '산마리노',
    nameEng: 'San Marino',
    code: 'SM',
    code3: 'SMR',
    phone: '378',
  },
  {
    nameKor: '생피에르 미클롱',
    nameEng: 'Saint Pierre and Miquelon',
    code: 'PM',
    code3: 'SPM',
    phone: '508',
  },
  {
    nameKor: '서사하라',
    nameEng: 'Western Sahara',
    code: 'EH',
    code3: 'ESH',
    phone: '212',
  },
  {
    nameKor: '세네갈',
    nameEng: 'Senegal',
    code: 'SN',
    code3: 'SEN',
    phone: '221',
  },
  {
    nameKor: '세르비아',
    nameEng: 'Serbia',
    code: 'RS',
    code3: 'SRB',
    phone: '381',
  },
  {
    nameKor: '세이셸',
    nameEng: 'Seychelles',
    code: 'SC',
    code3: 'SYC',
    phone: '248',
  },
  {
    nameKor: '세인트루시아',
    nameEng: 'Saint Lucia',
    code: 'LC',
    code3: 'LCA',
    phone: '1758',
  },
  {
    nameKor: '세인트헬레나',
    nameEng: 'Saint Helena',
    code: 'SH',
    code3: 'SHN',
    phone: '290',
  },
  {
    nameKor: '소말리아',
    nameEng: 'Somalia',
    code: 'SO',
    code3: 'SOM',
    phone: '252',
  },
  {
    nameKor: '솔로몬 제도',
    nameEng: 'Solomon Islands',
    code: 'SB',
    code3: 'SLB',
    phone: '677',
  },
  { nameKor: '수단', nameEng: 'Sudan', code: 'SD', code3: 'SDN', phone: '249' },
  {
    nameKor: '수리남',
    nameEng: 'Suriname',
    code: 'SR',
    code3: 'SUR',
    phone: '597',
  },
  {
    nameKor: '스리랑카',
    nameEng: 'Sri Lanka',
    code: 'LK',
    code3: 'LKA',
    phone: '94',
  },
  {
    nameKor: '스웨덴',
    nameEng: 'Sweden',
    code: 'SE',
    code3: 'SWE',
    phone: '46',
  },
  {
    nameKor: '스위스',
    nameEng: 'Switzerland',
    code: 'CH',
    code3: 'CHE',
    phone: '41',
  },
  {
    nameKor: '스페인',
    nameEng: 'Spain',
    code: 'ES',
    code3: 'ESP',
    phone: '34',
  },
  {
    nameKor: '슬로바키아',
    nameEng: 'Slovakia',
    code: 'SK',
    code3: 'SVK',
    phone: '421',
  },
  {
    nameKor: '슬로베니아',
    nameEng: 'Slovenia',
    code: 'SI',
    code3: 'SVN',
    phone: '386',
  },
  {
    nameKor: '시리아',
    nameEng: 'Syria',
    code: 'SY',
    code3: 'SYR',
    phone: '963',
  },
  {
    nameKor: '시에라리온',
    nameEng: 'Sierra Leone',
    code: 'SL',
    code3: 'SLE',
    phone: '232',
  },
  {
    nameKor: '신트마르턴',
    nameEng: 'Sint Maarten',
    code: 'SX',
    code3: 'SXM',
    phone: '1721',
  },
  {
    nameKor: '싱가포르',
    nameEng: 'Singapore',
    code: 'SG',
    code3: 'SGP',
    phone: '65',
  },
  {
    nameKor: '아랍에미리트',
    nameEng: 'United Arab Emirates',
    code: 'AE',
    code3: 'ARE',
    phone: '971',
  },
  {
    nameKor: '아루바',
    nameEng: 'Aruba',
    code: 'AW',
    code3: 'ABW',
    phone: '297',
  },
  {
    nameKor: '아르메니아',
    nameEng: 'Armenia',
    code: 'AM',
    code3: 'ARM',
    phone: '374',
  },
  {
    nameKor: '아르헨티나',
    nameEng: 'Argentina',
    code: 'AR',
    code3: 'ARG',
    phone: '54',
  },
  {
    nameKor: '아메리칸사모아',
    nameEng: 'American Samoa',
    code: 'AS',
    code3: 'ASM',
    phone: '1684',
  },
  {
    nameKor: '아이슬란드',
    nameEng: 'Iceland',
    code: 'IS',
    code3: 'ISL',
    phone: '354',
  },
  {
    nameKor: '아이티',
    nameEng: 'Haiti',
    code: 'HT',
    code3: 'HTI',
    phone: '509',
  },
  {
    nameKor: '아일랜드',
    nameEng: 'Ireland',
    code: 'IE',
    code3: 'IRL',
    phone: '353',
  },
  {
    nameKor: '아제르바이잔',
    nameEng: 'Azerbaijan',
    code: 'AZ',
    code3: 'AZE',
    phone: '994',
  },
  {
    nameKor: '아프가니스탄',
    nameEng: 'Afghanistan',
    code: 'AF',
    code3: 'AFG',
    phone: '93',
  },
  {
    nameKor: '안도라',
    nameEng: 'Andorra',
    code: 'AD',
    code3: 'AND',
    phone: '376',
  },
  {
    nameKor: '알바니아',
    nameEng: 'Albania',
    code: 'AL',
    code3: 'ALB',
    phone: '355',
  },
  {
    nameKor: '알제리',
    nameEng: 'Algeria',
    code: 'DZ',
    code3: 'DZA',
    phone: '213',
  },
  {
    nameKor: '앙골라',
    nameEng: 'Angola',
    code: 'AO',
    code3: 'AGO',
    phone: '244',
  },
  {
    nameKor: '앤티가 바부다',
    nameEng: 'Antigua and Barbuda',
    code: 'AG',
    code3: 'ATG',
    phone: '1268',
  },
  {
    nameKor: '앵귈라',
    nameEng: 'Anguilla',
    code: 'AI',
    code3: 'AIA',
    phone: '1264',
  },
  {
    nameKor: '에리트레아',
    nameEng: 'Eritrea',
    code: 'ER',
    code3: 'ERI',
    phone: '291',
  },
  {
    nameKor: '에스와티니',
    nameEng: 'Eswatini',
    code: 'SZ',
    code3: 'SWZ',
    phone: '268',
  },
  {
    nameKor: '에스토니아',
    nameEng: 'Estonia',
    code: 'EE',
    code3: 'EST',
    phone: '372',
  },
  {
    nameKor: '에콰도르',
    nameEng: 'Ecuador',
    code: 'EC',
    code3: 'ECU',
    phone: '593',
  },
  {
    nameKor: '에티오피아',
    nameEng: 'Ethiopia',
    code: 'ET',
    code3: 'ETH',
    phone: '251',
  },
  {
    nameKor: '엘살바도르',
    nameEng: 'El Salvador',
    code: 'SV',
    code3: 'SLV',
    phone: '503',
  },
  {
    nameKor: '영국',
    nameEng: 'United Kingdom',
    code: 'GB',
    code3: 'GBR',
    phone: '44',
  },
  { nameKor: '예멘', nameEng: 'Yemen', code: 'YE', code3: 'YEM', phone: '967' },
  { nameKor: '오만', nameEng: 'Oman', code: 'OM', code3: 'OMN', phone: '968' },
  {
    nameKor: '오스트레일리아',
    nameEng: 'Australia',
    code: 'AU',
    code3: 'AUS',
    phone: '61',
  },
  {
    nameKor: '오스트리아',
    nameEng: 'Austria',
    code: 'AT',
    code3: 'AUT',
    phone: '43',
  },
  {
    nameKor: '온두라스',
    nameEng: 'Honduras',
    code: 'HN',
    code3: 'HND',
    phone: '504',
  },
  {
    nameKor: '요르단',
    nameEng: 'Jordan',
    code: 'JO',
    code3: 'JOR',
    phone: '962',
  },
  {
    nameKor: '우간다',
    nameEng: 'Uganda',
    code: 'UG',
    code3: 'UGA',
    phone: '256',
  },
  {
    nameKor: '우루과이',
    nameEng: 'Uruguay',
    code: 'UY',
    code3: 'URY',
    phone: '598',
  },
  {
    nameKor: '우즈베키스탄',
    nameEng: 'Uzbekistan',
    code: 'UZ',
    code3: 'UZB',
    phone: '998',
  },
  {
    nameKor: '우크라이나',
    nameEng: 'Ukraine',
    code: 'UA',
    code3: 'UKR',
    phone: '380',
  },
  {
    nameKor: '이라크',
    nameEng: 'Iraq',
    code: 'IQ',
    code3: 'IRQ',
    phone: '964',
  },
  { nameKor: '이란', nameEng: 'Iran', code: 'IR', code3: 'IRN', phone: '98' },
  {
    nameKor: '이스라엘',
    nameEng: 'Israel',
    code: 'IL',
    code3: 'ISR',
    phone: '972',
  },
  {
    nameKor: '이집트',
    nameEng: 'Egypt',
    code: 'EG',
    code3: 'EGY',
    phone: '20',
  },
  {
    nameKor: '이탈리아',
    nameEng: 'Italy',
    code: 'IT',
    code3: 'ITA',
    phone: '39',
  },
  { nameKor: '인도', nameEng: 'India', code: 'IN', code3: 'IND', phone: '91' },
  {
    nameKor: '인도네시아',
    nameEng: 'Indonesia',
    code: 'ID',
    code3: 'IDN',
    phone: '62',
  },
  { nameKor: '일본', nameEng: 'Japan', code: 'JP', code3: 'JPN', phone: '81' },
  {
    nameKor: '자메이카',
    nameEng: 'Jamaica',
    code: 'JM',
    code3: 'JAM',
    phone: '1876',
  },
  {
    nameKor: '잠비아',
    nameEng: 'Zambia',
    code: 'ZM',
    code3: 'ZMB',
    phone: '260',
  },
  {
    nameKor: '적도 기니',
    nameEng: 'Equatorial Guinea',
    code: 'GQ',
    code3: 'GNQ',
    phone: '240',
  },
  {
    nameKor: '북한',
    nameEng: 'DPR of Korea',
    code: 'KP',
    code3: 'PRK',
    phone: '850',
  },
  {
    nameKor: '조지아',
    nameEng: 'Georgia',
    code: 'GE',
    code3: 'GEO',
    phone: '995',
  },
  {
    nameKor: '중앙아프리카 공화국',
    nameEng: 'Central Africa',
    code: 'CF',
    code3: 'CAF',
    phone: '236',
  },
  {
    nameKor: '대만',
    nameEng: 'Taiwan',
    code: 'TW',
    code3: 'TWN',
    phone: '886',
  },
  {
    nameKor: '중화인민공화국',
    nameEng: 'China',
    code: 'CN',
    code3: 'CHN',
    phone: '86',
  },
  {
    nameKor: '지부티',
    nameEng: 'Djibouti',
    code: 'DJ',
    code3: 'DJI',
    phone: '253',
  },
  {
    nameKor: '지브롤터',
    nameEng: 'Gibraltar',
    code: 'GI',
    code3: 'GIB',
    phone: '350',
  },
  {
    nameKor: '짐바브웨',
    nameEng: 'Zimbabwe',
    code: 'ZW',
    code3: 'ZWE',
    phone: '263',
  },
  { nameKor: '차드', nameEng: 'Chad', code: 'TD', code3: 'TCD', phone: '235' },
  { nameKor: '체코', nameEng: 'Czech', code: 'CZ', code3: 'CZE', phone: '420' },
  { nameKor: '칠레', nameEng: 'Chile', code: 'CL', code3: 'CHL', phone: '56' },
  {
    nameKor: '카메룬',
    nameEng: 'Cameroon',
    code: 'CM',
    code3: 'CMR',
    phone: '237',
  },
  {
    nameKor: '카보베르데',
    nameEng: 'Cape Verde',
    code: 'CV',
    code3: 'CPV',
    phone: '238',
  },
  {
    nameKor: '카자흐스탄',
    nameEng: 'Kazakstan',
    code: 'KZ',
    code3: 'KAZ',
    phone: '7',
  },
  {
    nameKor: '카타르',
    nameEng: 'Qatar',
    code: 'QA',
    code3: 'QAT',
    phone: '974',
  },
  {
    nameKor: '캄보디아',
    nameEng: 'Cambodia',
    code: 'KH',
    code3: 'KHM',
    phone: '855',
  },
  {
    nameKor: '캐나다',
    nameEng: 'Canada',
    code: 'CA',
    code3: 'CAN',
    phone: '1',
  },
  { nameKor: '케냐', nameEng: 'Kenya', code: 'KE', code3: 'KEN', phone: '254' },
  {
    nameKor: '케이맨 제도',
    nameEng: 'Cayman Islands',
    code: 'KY',
    code3: 'CYM',
    phone: '1345',
  },
  {
    nameKor: '코모로',
    nameEng: 'the Comoros',
    code: 'KM',
    code3: 'COM',
    phone: '269',
  },
  {
    nameKor: '코스타리카',
    nameEng: 'Costa Rica',
    code: 'CR',
    code3: 'CRI',
    phone: '506',
  },
  {
    nameKor: '코트디부아르',
    nameEng: 'Ivory Coast',
    code: 'CI',
    code3: 'CIV',
    phone: '225',
  },
  {
    nameKor: '콜롬비아',
    nameEng: 'Colombia',
    code: 'CO',
    code3: 'COL',
    phone: '57',
  },
  {
    nameKor: '콩고 공화국',
    nameEng: 'Congo',
    code: 'CG',
    code3: 'COG',
    phone: '242',
  },
  {
    nameKor: '콩고 민주 공화국',
    nameEng: 'DR Congo',
    code: 'CD',
    code3: 'COD',
    phone: '243',
  },
  { nameKor: '쿠바', nameEng: 'Cuba', code: 'CU', code3: 'CUB', phone: '53' },
  {
    nameKor: '쿠웨이트',
    nameEng: 'Kuwait',
    code: 'KW',
    code3: 'KWT',
    phone: '965',
  },
  {
    nameKor: '쿡 제도',
    nameEng: 'Cook Islands',
    code: 'CK',
    code3: 'COK',
    phone: '682',
  },
  {
    nameKor: '크로아티아',
    nameEng: 'Croatia',
    code: 'HR',
    code3: 'HRV',
    phone: '385',
  },
  {
    nameKor: '키르기스스탄',
    nameEng: 'Kyrgizstan',
    code: 'KG',
    code3: 'KGZ',
    phone: '996',
  },
  {
    nameKor: '키리바시',
    nameEng: 'Kiribati',
    code: 'KI',
    code3: 'KIR',
    phone: '686',
  },
  {
    nameKor: '키프로스',
    nameEng: 'Cyprus',
    code: 'CY',
    code3: 'CYP',
    phone: '357',
  },
  {
    nameKor: '타지키스탄',
    nameEng: 'Tajikistan',
    code: 'TJ',
    code3: 'TJK',
    phone: '992',
  },
  {
    nameKor: '탄자니아',
    nameEng: 'Tanzania',
    code: 'TZ',
    code3: 'TZA',
    phone: '255',
  },
  {
    nameKor: '태국',
    nameEng: 'Thailand',
    code: 'TH',
    code3: 'THA',
    phone: '66',
  },
  { nameKor: '터키', nameEng: 'Turkey', code: 'TR', code3: 'TUR', phone: '90' },
  { nameKor: '토고', nameEng: 'Togo', code: 'TG', code3: 'TGO', phone: '228' },
  {
    nameKor: '토켈라우',
    nameEng: 'Tokelau',
    code: 'TK',
    code3: 'TKL',
    phone: '690',
  },
  { nameKor: '통가', nameEng: 'Tonga', code: 'TO', code3: 'TON', phone: '676' },
  {
    nameKor: '투르크메니스탄',
    nameEng: 'Turkmenistan',
    code: 'TM',
    code3: 'TKM',
    phone: '993',
  },
  {
    nameKor: '투발루',
    nameEng: 'Tuvalu',
    code: 'TV',
    code3: 'TUV',
    phone: '688',
  },
  {
    nameKor: '튀니지',
    nameEng: 'Tunisia',
    code: 'TN',
    code3: 'TUN',
    phone: '216',
  },
  {
    nameKor: '트리니다드 토바고',
    nameEng: 'Trinidad and Tobago',
    code: 'TT',
    code3: 'TTO',
    phone: '1868',
  },
  {
    nameKor: '파나마',
    nameEng: 'Panama',
    code: 'PA',
    code3: 'PAN',
    phone: '507',
  },
  {
    nameKor: '파라과이',
    nameEng: 'Paraguay',
    code: 'PY',
    code3: 'PRY',
    phone: '595',
  },
  {
    nameKor: '파키스탄',
    nameEng: 'Pakistan',
    code: 'PK',
    code3: 'PAK',
    phone: '92',
  },
  {
    nameKor: '파푸아뉴기니',
    nameEng: 'Papua New Guinea',
    code: 'PG',
    code3: 'PNG',
    phone: '675',
  },
  {
    nameKor: '팔라우',
    nameEng: 'Palau',
    code: 'PW',
    code3: 'PLW',
    phone: '680',
  },
  {
    nameKor: '팔레스타인',
    nameEng: 'State of Palestine',
    code: 'PS',
    code3: 'PSE',
    phone: '970',
  },
  { nameKor: '페루', nameEng: 'Peru', code: 'PE', code3: 'PER', phone: '51' },
  {
    nameKor: '포르투갈',
    nameEng: 'Portugal',
    code: 'PT',
    code3: 'PRT',
    phone: '351',
  },
  {
    nameKor: '포클랜드 제도',
    nameEng: 'Falkland Islands',
    code: 'FK',
    code3: 'FLK',
    phone: '500',
  },
  {
    nameKor: '폴란드',
    nameEng: 'Poland',
    code: 'PL',
    code3: 'POL',
    phone: '48',
  },
  {
    nameKor: '푸에르토리코',
    nameEng: 'Puerto Rico',
    code: 'PR',
    code3: 'PRI',
    phone: '1787',
  },
  {
    nameKor: '프랑스',
    nameEng: 'France',
    code: 'FR',
    code3: 'FRA',
    phone: '33',
  },
  { nameKor: '피지', nameEng: 'Fiji', code: 'FJ', code3: 'FJI', phone: '679' },
  {
    nameKor: '핀란드',
    nameEng: 'Finland',
    code: 'FI',
    code3: 'FIN',
    phone: '358',
  },
  {
    nameKor: '필리핀',
    nameEng: 'the Philippines',
    code: 'PH',
    code3: 'PHL',
    phone: '63',
  },
  {
    nameKor: '헝가리',
    nameEng: 'Hungary',
    code: 'HU',
    code3: 'HUN',
    phone: '36',
  },
  {
    nameKor: '홍콩',
    nameEng: 'Hong Kong',
    code: 'HK',
    code3: 'HKG',
    phone: '852',
  },
];
